<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			企业管理
		</div>

		<div @click="isShow = !isShow"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加企业管理
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: left;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;">
				添加企业信息
			</div>
		</div> -->

		<el-dialog title="企业联系人添加" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<el-form label-width="100px" :model="formLabelAlign">
				<el-form-item label="联系人姓名">
					<el-input v-model="formLabelAlign.lxr"></el-input>
				</el-form-item>
				<el-form-item label="手机号码">
					<el-input v-model="formLabelAlign.mbphone"></el-input>
				</el-form-item>
				<el-form-item label="职位">
					<el-input v-model="formLabelAlign.zy"></el-input>
				</el-form-item>
				<div style="width: 100%;height: 50px;margin-top: 25px;margin-bottom: 25px;">
					<div
						style="width: 150px;height: 50px;float: left;line-height: 50px;text-align: left;font-size: 16px;">
						联系人照片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="tjlxra">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="企业联系人修改" :visible.sync="dialogVisibles" width="30%" :before-close="handleClose">
			<el-form label-width="100px" :model="formLabelAlign">
				<el-form-item label="联系人姓名">
					<el-input v-model="formLabelAlign.lxr"></el-input>
				</el-form-item>
				<el-form-item label="手机号码">
					<el-input v-model="formLabelAlign.mbphone"></el-input>
				</el-form-item>
				<el-form-item label="职位">
					<el-input v-model="formLabelAlign.zy"></el-input>
				</el-form-item>
				<div style="width: 100%;height: 50px;margin-top: 25px;margin-bottom: 25px;">
					<div
						style="width: 150px;height: 50px;float: left;line-height: 50px;text-align: left;font-size: 16px;">
						联系人照片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibles = false">取 消</el-button>
				<el-button type="primary" @click="qylxrxg">确 定</el-button>
			</span>
		</el-dialog>

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="height: 1200px;text-align: left;">
				<!-- 暂无选中内容 -->
				<div style="width: 100%;height: 100px;" v-for="(item,index) in qygla" :key="index">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;">
							{{item.title}}
						</div>
						<div v-show="item.look=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;text-align: left;">
							未查看
						</div>
						<div v-show="item.look=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;text-align: center;">
							已查看
						</div>
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}  
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;text-align: center;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link :to="{ path:'/qydqdetail',query:{id:item.id,title:item.title} }" tag="div"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="tjlxr(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 240px;border: 1px solid #6e6e6e;text-align: center;">
							添加联系人
						</div>
						<el-popover placement="right"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 130px;border: 1px solid #6e6e6e;text-align: center;"
							trigger="click">
							<el-table :data="gridData">
								<el-table-column width="150" property="lxr" label="联系人"></el-table-column>
								<el-table-column width="150" property="zy" label="职位"></el-table-column>
								<el-table-column width="300" property="mbphone" label="手机号码"></el-table-column>
								<el-table-column width="150" label="操作">
									<template slot-scope="scope">
										<el-button type="primary" @click="updates(scope.row)" icon="el-icon-edit"
											circle></el-button>
										<el-button type="danger" @click="deleted(scope.row)" icon="el-icon-delete"
											circle></el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-button @click="cklxra(item)"
								style="width: 100px;height: 30px;text-align: center;line-height: 30px;padding: 0;"
								slot="reference">查看联系人</el-button>
						</el-popover>
						<!-- <div @click="tjlxr(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 130px;border: 1px solid #6e6e6e;text-align: center;">
							查看联系人
						</div> -->
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;text-align: center;">
							删除
						</div>

					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="isShow">

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						名称:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size: 16px;">
						封面照片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;margin-bottom: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size: 16px;">
						企业二维码:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccesssss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListsss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						热招岗位:
					</div>
					<el-input v-model="form.recruitpost" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						是否上市:
					</div>
					<el-radio-group v-model="form.onmarket" style="float: left;width: 70%;margin-top: 5px;">
						<el-radio-button label="0">是</el-radio-button>
						<el-radio-button label="1">否</el-radio-button>
					</el-radio-group>
				</div> -->


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						主营产品:
					</div>
					<el-input v-model="form.mainsell" style="float: left;width: 50%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						经营模式:
					</div>
					<el-input v-model="form.zy" style="float: left;width: 50%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						栏目ID:
					</div>
					<el-cascader class="eloptionxg" :value="selectOrg"  :options="industry" @change="handleAreaChange" filterable>
					</el-cascader>
				</div>


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						官网地址:
					</div>
					<el-input v-model="form.guanlink" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						VR地址:
					</div>
					<el-input v-model="form.vrlink" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						邮编:
					</div>
					<el-input v-model="form.youbian" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						公司类别:
					</div>
					<el-input v-model="form.gslb" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->


				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						经度 <a href="http://api.map.baidu.com/lbsapi/getpoint/index.html"
							style="font-size: 12px;">获取经纬度</a> :
					</div>
					<el-input v-model="form.posix" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						纬度 <a href="http://api.map.baidu.com/lbsapi/getpoint/index.html"
							style="font-size: 12px;">获取经纬度</a> :
					</div>
					<el-input v-model="form.posiy" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						地址:
					</div>
					<el-input @blur="qbesssa" v-model="form.address" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						地区:
					</div>
					<el-select style="float: left;margin-top: 5px;" v-model="form.area" filterable placeholder="请选择">
						<el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						邮箱:
					</div>
					<el-input v-model="form.mail" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						传真:
					</div>
					<el-input v-model="form.fax" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						座机:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						手机号码:
					</div>
					<el-input v-model="form.mbphone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						职位:
					</div>
					<el-input v-model="form.zw" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						联系人:
					</div>
					<el-input v-model="form.lxr" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;margin-bottom: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size: 16px;">
						联系人照片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div> -->





				<div style="width: 100%;height: 550px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: left;font-size:16px;">
						简介:
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.describtion" :setting="setting" />
					</div>
				</div>





				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary"  @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft alignleft alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',

				},
				isShow: false,
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				cnmuid: '',
				options: [],
				imageUrl: '',
				imageUrlend: '',
				optionss: [{
						value: '北京市',
						label: '北京市'
					},
					{
						value: '上海市',
						label: '上海市'
					}, {
						value: '天津市',
						label: '天津市'
					}, {
						value: '重庆市',
						label: '重庆市'
					}, {
						value: '河北省',
						label: '河北省'
					}, {
						value: '山西省',
						label: '山西省'
					}, {
						value: '辽宁省',
						label: '辽宁省'
					}, {
						value: '吉林省',
						label: '吉林省'
					}, {
						value: '河南省',
						label: '河南省'
					}, {
						value: '江苏省',
						label: '江苏省'
					}, {
						value: '浙江省',
						label: '浙江省'
					}, {
						value: '安徽省',
						label: '安徽省'
					}, {
						value: '福建省',
						label: '福建省'
					}, {
						value: '江西省',
						label: '江西省'
					}, {
						value: '山东省',
						label: '山东省'
					}, {
						value: '湖北省',
						label: '湖北省'
					}, {
						value: '湖南省',
						label: '湖南省'
					}, {
						value: '广东省',
						label: '广东省'
					}, {
						value: '海南省',
						label: '海南省'
					}, {
						value: '四川省',
						label: '四川省'
					}, {
						value: '贵州省',
						label: '贵州省'
					}, {
						value: '云南省',
						label: '云南省'
					}, {
						value: '陕西省',
						label: '陕西省'
					}, {
						value: '甘肃省',
						label: '甘肃省'
					}, {
						value: '青海省',
						label: '青海省'
					}, {
						value: '黑龙江省',
						label: '黑龙江省'
					}, {
						value: '内蒙古自治区',
						label: '内蒙古自治区'
					}, {
						value: '广西壮族自治区',
						label: '广西壮族自治区'
					}, {
						value: '西藏自治区',
						label: '西藏自治区'
					}, {
						value: '宁夏回族自治区',
						label: '宁夏回族自治区'
					}, {
						value: '新疆维吾尔自治区',
						label: '新疆维吾尔自治区'
					}, {
						value: '台湾省',
						label: '台湾省'
					}, {
						value: '香港特别行政区',
						label: '香港特别行政区'
					}, {
						value: '澳门特别行政区',
						label: '澳门特别行政区'
					}, {
						value: '其它',
						label: '其它'
					}
				],
				fileListss: [],
				fileListsss: [],
				fileListssss: [],
				form: {
					logo: '',
					qyewm: '',
					recruitpost: '',
					onmarket: '',
					list: '',
					zy: '',
					zw: '',
					shoplink: '',
					guanlink: '',
					youbian: '',
					posix: '',
					posiy: '',
					address: '',
					mail: '',
					fax: '',
					phone: '',
					lxr: '',
					content: '',
					zhaopiana: '',
					area: '',
					title: '',
					vrlink: '',
					mbphone: '',
					lxrpicture: '',
					gslb: '',
					fid: '',
				},
				selectOrg:[],
				xsa: false,
				qygla: '',
				gridData: [],
				qid: '',
				dialogVisible: false,
				dialogVisibles: false,
				qyid: '',
				ntmsbb:false,
				qyids: '',
				industry: [],
				formLabelAlign: {
					lxr: '',
					lxrpicture: '',
					zy: '',
					mbphone: '',
				},
				qbesss: '',
			}
		},
		methods: {
			querySearchAsync(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					cb(results);
				}, 3000 * Math.random());
			},
			handleSelect(item) {
				console.log(item);
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			async qbesssa(){
				console.log(this.form.address)
				let res = await http.get('api/picture/queryAddress',{
					address:this.form.address
				})
				console.log(res)
				if(res.data.code==200){
					this.ntmsbb = true
					this.form.posix = res.data.data.posix
					this.form.posiy = res.data.data.posiy
				} else {
					alert('请重新填写地址')
				}
			},
			tjlxr(item) {
				// console.log(item)
				this.dialogVisible = true
				this.qyid = item
			},
			async qylxrxg() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/qylxrl_edit', {
					id: this.qyids.id,
					uid: loginInfo.id,
					lxr: this.formLabelAlign.lxr,
					lxrpicture: this.formLabelAlign.lxrpicture,
					zy: this.formLabelAlign.zy,
					mbphone: this.formLabelAlign.mbphone
				})
				console.log(res)
				if (res.data.code == 200) {
					this.$message.warning('修改成功');
					this.dialogVisibles = false
					this.formLabelAlign.lxr = ''
					this.formLabelAlign.lxrpicture = ''
					this.formLabelAlign.mbphone = ''
					this.formLabelAlign.zy = ''
				}
			},
			async tjlxra() {
				if(this.formLabelAlign.lxrpicture==''){
					this.formLabelAlign.lxrpicture = 'api/1662473183236.jpg'
				}
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/qylxr_add', {
					fid: this.qyid.id,
					uid: loginInfo.id,
					lxr: this.formLabelAlign.lxr,
					lxrpicture: this.formLabelAlign.lxrpicture,
					zy: this.formLabelAlign.zy,
					mbphone: this.formLabelAlign.mbphone
				})
				console.log(res)
				if (res.data.code == 200) {
					this.$message.warning('添加成功');
					this.dialogVisible = false
					this.formLabelAlign.lxr = ''
					this.formLabelAlign.lxrpicture = ''
					this.formLabelAlign.mbphone = ''
					this.formLabelAlign.zy = ''
				}
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'qybd',
					type: 'content',
					mid: '4',
					field_name: 'id',
					field_id: id,
					uid: loginInfo.id
				})
				console.log(res)
				if (res.data.code == 200) {
					this.qbe()
				}
			},
			async deleted(sb) {
				console.log(sb)
				let qbe = await http.get('api/picture/qylxrl_delete', {
					id: sb.id
				})
				console.log(qbe)
				this.$message.warning('删除成功');
				this.qbesss = sb
				this.cklxra()
				this.qbe()
			},
			handleChange(value) {},
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
				this.form.logo = res.data.path
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccessss(response, file, fileList) {
				this.form.logo = response.data.path
			},
			handsuccesssss(response, file, fileList) {
				this.form.qyewm = response.data.path
			},
			async cklxra(item) {
				console.log(item)
				if (item == undefined) {
					let qbe = await http.get('api/picture/qylxrl_index', {
						id: this.qbesss.id
					})
					console.log(qbe)
					this.gridData = qbe.data.data.list
				} else {
					let qbe = await http.get('api/picture/qylxrl_index', {
						id: item.id
					})
					console.log(qbe)
					this.gridData = qbe.data.data.list
				}

			},
			handsuccessssss(response, file, fileList) {
				this.form.lxrpicture = response.data.path
				this.formLabelAlign.lxrpicture = response.data.path
			},
			handleAvatarSuccessend(res, file) {
				this.imageUrlend = URL.createObjectURL(file.raw);
				this.form.qyewm = res.data.path
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			beforeAvatarUploadend(file) {

			},
			beforeAvatarUpload(file) {

			},
			setup(editor) {
				console.log(editor)
			},
			xiugaia(val) {
				console.log(val)
				var that = this
				this.isShow = true
				this.xsa = true
				// this.form.fid = val.fid
				this.form.logo = val.logo
				this.form.qyewm = val.qyewm
				this.form.recruitpost = val.recruitpost
				this.form.onmarket = val.onmarket
				this.form.list = val.list
				this.form.zw = val.zw
				this.form.shoplink = val.shoplink
				this.form.guanlink = val.guanlink
				this.form.youbian = val.youbian
				this.form.posix = val.posix
				this.form.posiy = val.posiy
				this.form.address = val.address
				this.form.mail = val.mail
				this.form.fax = val.fax
				this.form.phone = val.phone
				this.form.lxr = val.lxr
				this.form.mainsell = val.mainsell
				this.form.content = val.content
				this.form.zy = val.zy
				this.form.zhaopiana = val.zhaopiana
				this.form.area = val.area
				this.form.title = val.title
				this.form.vrlink = val.vrlink
				this.form.mbphone = val.mbphone
				this.form.describtion = val.describtion
				this.form.lxrpicture = val.lxrpicture
				this.qid = val.id

				this.industry.forEach((item) => {
					item.children.forEach(ites => {

						if (ites.value == val.fid)
							this.selectOrg = [item.value,ites.value]
						return that.form.fid = ites.label
					})
				})
			
				console.log(this.selectOrg[1])
				let fileArrs = [];
				let fileObjs = {};
				fileObjs.name = "图片";
				fileObjs.url = val.logo;
				fileArrs.push(fileObjs);
				this.fileListss = fileArrs


				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name = "二维码";
				fileObjss.url = val.qyewm;
				fileArrss.push(fileObjss);
				this.fileListsss = fileArrss

				let fileArrsss = [];
				let fileObjsss = {};
				fileObjsss.name = "联系人照片";
				fileObjsss.url = val.lxrpicture;
				fileArrsss.push(fileObjsss);
				this.fileListssss = fileArrsss
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/person_page_qy', {
					uid: loginInfo.id,
					page: val
				})
				console.log(res)
				this.qygla = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async qbe() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.cnmuid = loginInfo.id
				let res = await http.post('api/picture/person_qy_index', {
					uid: this.cnmuid
				})
				console.log(res)
				this.qygla = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			updates(sb) {
				this.qyids = sb
				this.dialogVisibles = true
				this.formLabelAlign.lxr = sb.lxr
				this.formLabelAlign.lxrpicture = sb.lxrpicture
				this.formLabelAlign.zy = sb.zy
				this.formLabelAlign.mbphone = sb.mbphone

				let fileArrs = [];
				let fileObjs = {};
				fileObjs.name = "联系人照片";
				fileObjs.url = sb.lxrpicture;
				fileArrs.push(fileObjs);
				this.fileListssss = fileArrs
			},
			async handleAreaChange(val) {
				console.log(val[1])
				if(this.xsa == true){
					this.selectOrg[1] = val[1]
				} else {
					this.form.fid = val[1]
				}
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.cnmuid = loginInfo.id
				if (this.xsa == true) {
					console.log(this.selectOrg[1])
					let res = await http.post('api/Common/edit', {
						model: 'qydb',
						type: 'content',
						mid: '4',
						fid: this.selectOrg[1],
						logo: this.form.logo,
						qyewm: this.form.qyewm,
						recruitpost: this.form.recruitpost,
						onmarket: this.form.onmarket,
						list: this.form.list,
						zw: this.form.zw,
						mainsell: this.form.mainsell,
						shoplink: this.form.shoplink,
						guanlink: this.form.guanlink,
						youbian: this.form.youbian,
						posix: this.form.posix,
						posiy: this.form.posiy,
						zy: this.form.zy,
						address: this.form.address,
						mail: this.form.mail,
						fax: this.form.fax,
						phone: this.form.phone,
						lxr: this.form.lxr,
						content: this.form.content,
						zhaopiana: this.form.zhaopiana,
						area: this.form.area,
						title: this.form.title,
						uid: this.cnmuid,
						vrlink: this.vrlink,
						mbphone: this.mbphone,
						describtion: this.form.describtion,
						lxrpicture: this.lxrpicture,
						id: this.qid,
						uid: this.cnmuid
					})
					this.xsa = false
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '添加成功需要审核才能显示',
							type: 'success'
						});
					}
					this.qbe()
					this.form = []
				} else if (this.xsa == false) {
					if(this.ntmsbb == false){
						alert('填写地址')
						return
					}
					
					let res1 = await http.post('api/Common/add', {
						model: 'qydb',
						type: 'content',
						mid: '4',
						fid: this.form.fid,
						icon: this.form.icon,
						qyewm: this.form.qyewm,
						zy: this.form.zy,
						recruitpost: this.form.recruitpost,
						onmarket: this.form.onmarket,
						list: this.form.list,
						mainsell: this.form.mainsell,
						zw: this.form.zw,
						content: this.form.content,
						shoplink: this.form.shoplink,
						guanlink: this.form.guanlink,
						youbian: this.form.youbian,
						logo: this.form.logo,
						posix: this.form.posix,
						posiy: this.form.posiy,
						address: this.form.address,
						mail: this.form.mail,
						fax: this.form.fax,
						phone: this.form.phone,
						lxr: this.form.lxr,
						describtion: this.form.describtion,
						zhaopiana: this.form.zhaopiana,
						area: this.form.area,
						title: this.form.title,
						uid: this.form.cnmuid,
						vrlink: this.form.vrlink,
						mbphone: this.form.mbphone,
						describtion: this.form.describtion,
						lxrpicture: this.form.lxrpicture,
						uid: this.cnmuid
					})

					this.xsa = false
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '添加成功需要审核才能显示',
							type: 'success'
						});
					} else {
						this.$notify({
							title: '添加失败',
							message: '联系客服021-59145813，升级VIP会员才可添加',
							type: 'error'
						});
					}
					this.qbe()
					this.form = []
				}
			}
		},
		async mounted() {
			let res = await http.get('api/qydb/index')
			let batchdata = res.data.data
			let dataValueBatch = batchdata => batchdata.map(({
				id,
				name,
				child_1
			}) => (child_1 ? {
				value: id,
				label: name,
				children: dataValueBatch(child_1)
			} : {
				value: id,
				label: name
			}))
			this.options = dataValueBatch(batchdata)
			console.log(this.options)
			this.industry = dataValueBatch(batchdata)

			this.qbe()


		},
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: left;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	/deep/ .el-upload__input {
		display: none;
	}
</style>
